module.exports = __webpack_public_path__ + "img/dr_11.d2bcf87a.png";